import React from 'react';

import { PageTitle } from 'src/components/Page';
import { PopupDefaultProps, PopupPropTypes } from 'src/components/Popup/propTypes';
import Styled from 'src/components/Popup/Popup.styles';

const Popup = ({
  children,
  customTitle,
  isCloseHidden,
  level,
  onClose,
  title,
  ...rest
}) => {
  return (
    <Styled.Container>
      <Styled.ContainerInner level={level} {...rest}>
        {!isCloseHidden && (
          <Styled.CloseBtn name="cross" onClick={onClose} />
        )}
        {title ? <PageTitle>{title}</PageTitle> : null}
        {customTitle ?? null}

        {children}
      </Styled.ContainerInner>
    </Styled.Container>
  );
};

Popup.propTypes = PopupPropTypes;
Popup.defaultProps = PopupDefaultProps;

export default React.memo(Popup);
